/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.publicProducts

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import okio.FileSystem
import features.publicProducts.internal.PublicProductsUseCase
import features.publicProducts.internal.PublicProductsUseCase.Params
import features.publicProducts.models.PublicProductsModel


typealias PublicProductsState = CFlow<PublicProductsUseCaseResult?>

typealias PublicProductsUseCaseResult = Result<PublicProductsModel>

fun PublicProductsUseCaseResult.serializePublicProductsApiResult(): SerializedResult<String> {
    return this.toJsonResult<PublicProductsModel>()
}

/**
 * Serializes [PublicProductsState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun PublicProductsState.serializePublicProductsState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<PublicProductsModel>()
    }.asCFlow()
}

/**
 * Get a list of products available to all users. [Api] class
 */
class PublicProductsApi : Api() {

    val publicProductsState: PublicProductsState
        get() = _publicProductsState.asCFlow()

    companion object {
        private val _publicProductsState: MutableStateFlow<PublicProductsUseCaseResult> = MutableStateFlow(Idle())
    }

    private val publicProductsUseCase = PublicProductsUseCase()

    /**
     * Get a list of products available to all users.
     */
    suspend fun getPublicProducts(
        overrideHeaders: Map<String, String>? = null,

    ): Result<PublicProductsModel> {
        /* set state to Loading as soon as function is called */
        _publicProductsState.value = Loading()
        val result = this.publicProductsUseCase(
            Params(
                overrideHeaders = overrideHeaders,

            )
        
        ) { result ->
            _publicProductsState.value = result
            return@publicProductsUseCase result
        }
        return result
    }

}
